import { useRouter } from "next/navigation";
import { useEffect, useReducer } from "react";

import reducer from "@/utils/variant/reducer";
import type { VariantState } from "types/variant";

export type VariantSelectorProps = {
  state: VariantState;
  className?: string;
};

export default function useVariantSelector(
  props: Omit<VariantSelectorProps, "dictionary">,
) {
  const { state: variantState } = props;
  const router = useRouter();
  const [state, dispatch] = useReducer(reducer, variantState);

  const onChange = (key: string, value: string | number | boolean) => {
    dispatch({ type: "SELECT", key, value });
  };

  useEffect(() => {
    if (state.variant) {
      if (!window.location.search.includes(state.variant.key)) {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set("variant", state.variant.key);
        router.push(window.location.pathname + "?" + searchParams.toString(), {
          scroll: false,
        });
      }
    }
  }, [router, state.variant]);

  return { onChange, state };
}
